import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { ModalCompleteYourProfile } from "components";
import NoItemsMessageCard from "components/NoItemsMessageCard";
import IconMentoring from "images/icon-mentoring-new.svg";

import { Avatar, Button } from "antd";

import "./style.scss";
import { LinkedinOutlined, MailOutlined } from "@ant-design/icons";

const YourCurrentMentees = ({
  requestListMentor,
  mentorProfile,
  menteeProfile,
  userProfile,
  getUser,
}) => {
  const [bulModal, setBulModal] = useState(false);
  const [mentorData, setMentorData] = useState({
    textDescriptionMentor: mentorProfile?.textDescription,
    textDescriptionMentee: menteeProfile?.textDescription,
  });

  useEffect(() => {
    setMentorData({
      ...mentorData,
      textDescriptionMentor: mentorProfile?.textDescription,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mentorProfile]);

  useEffect(() => {
    setMentorData({
      ...mentorData,
      textDescriptionMentee: menteeProfile?.textDescription,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menteeProfile]);

  const onCloseModal = () => {
    setBulModal(false);
    setMentorData({
      textDescriptionMentor: mentorProfile?.textDescription,
      textDescriptionMentee: menteeProfile?.textDescription,
    });
  };

  const filterSituation = (data) => {
    return data?.filter((e) => {
      return (
        e.status.toUpperCase() === "ACCEPTED" &&
        e.idUser !== mentorProfile.idUser
      );
    });
  };

  return (
    <div className="container-current">
      {/* <div
        //   className="container-buttom"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <CustomButton
          key="PREVIEW PROFILE"
          text="PREVIEW PROFILE"
          type="primary"
          size="xl"
          className="button-modal"
          style={{ padding: "0px 10px" }}
          onClick={() => {
            setBulModal(true);
          }}
        />
      </div> */}
      <div className="container-list-request">
        {requestListMentor &&
        filterSituation(requestListMentor)?.length !== 0 ? (
          filterSituation(requestListMentor)?.map((data, index) => {
            return (
              <div key={index} className="container-card-user-mentoring">
                <div className="first-part">
                  <div style={{ width: "100px", height: "100px" }}>
                    {data?.img ? (
                      <Avatar size={100} src={data?.img} />
                    ) : (
                      <Avatar size={100} style={{ fontSize: "1rem" }}>
                        {data?.abbrName}
                      </Avatar>
                    )}
                  </div>
                  <div className="container-name">
                    <p style={{ fontSize: "18px" }}>{data.firstName}</p>
                    <p style={{ fontSize: "18px" }}>{data.titleProfessions}</p>
                  </div>
                  <div className="container-buttons-linkedin-email">
                    <a
                      href={data?.personalLinks?.linkedin || "#"}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <Button
                        shape="circle"
                        type="link"
                        icon={<LinkedinOutlined />}
                        className="icon-linkedin"
                      />
                    </a>
                    <a href={`mailto:${data?.email}`}>
                      <Button
                        shape="circle"
                        type="link"
                        icon={<MailOutlined />}
                        className="icon-email"
                      />
                    </a>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div style={{ marginTop: "25px" }}>
            <NoItemsMessageCard
              icon={IconMentoring}
              message={`There aren't current mentees`}
            />
          </div>
        )}
      </div>
      {/* <div className="container-buttom">
                <CustomButton
                    key="PREVIEW PROFILE"
                    text="PREVIEW PROFILE"
                    type="primary"
                    size="xl"
                    className="button-modal"
                    style={{ padding: "0px 10px" }}
                    onClick={() => { setBulModal(true) }}
                />
            </div> */}
      {bulModal === true && (
        <div className="complete-profile" onClick={() => setBulModal(false)}>
          <ModalCompleteYourProfile
            userProfile={userProfile}
            get={getUser}
            edit={false}
            caseMentoring={true}
            mentee={mentorData?.textDescriptionMentee}
            mentor={mentorData?.textDescriptionMentor}
            onClose={() => onCloseModal()}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(YourCurrentMentees);
